export const environmentAll = {
    releaseVersion: 1.11,
    earliestReleaseVersion: 1.04,
    ignoredReleaseVersions: [ 1.07 ]
  };
